import { useQuery } from 'convex/react';
import { api } from '@aeon-karaoke/cloud-convex';
import type { Id } from '@aeon-karaoke/cloud-convex/_generated/dataModel';

export function useTrack(trackId: Id<'tracks'> | undefined) {
  return useQuery(api.tracks.get, trackId ? { trackId } : 'skip');
}
